module.exports = __webpack_public_path__ + "static/media/adult-skriv-tutorial_fast.662653c5.mp4";